import { render, staticRenderFns } from "./shopping-add.vue?vue&type=template&id=3dfb1c02&scoped=true"
import script from "./shopping-add.vue?vue&type=script&lang=js"
export * from "./shopping-add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb1c02",
  null
  
)

export default component.exports